export interface ScoringBonus {
  stat: string;
  every: string;
}

export interface ScoringRole {
  pos: string;
  label: string;
  color: string;
  chipBg: string;
  chipBorder: string;
  bonuses: ScoringBonus[];
  goal: string;
  clean: string;
}

export interface SharedEvent {
  label: string;
  pts: string;
  color: string;
}

const BONUS: Record<string, Array<[string, number]>> = {
  CB: [
    ['Tackles', 4],
    ['Interceptions', 2],
    ['Duels won', 5],
    ['Passes completed', 50],
  ],
  WCB: [
    ['Tackles', 4],
    ['Interceptions', 2],
    ['Duels won', 5],
    ['Passes completed', 50],
  ],
  RB: [
    ['Tackles', 4],
    ['Interceptions', 2],
    ['Dribbles', 2],
    ['Passes completed', 35],
  ],
  LB: [
    ['Tackles', 4],
    ['Interceptions', 2],
    ['Dribbles', 2],
    ['Passes completed', 35],
  ],
  RWB: [
    ['Dribbles', 3],
    ['Key passes', 2],
    ['Tackles', 3],
    ['Passes completed', 35],
  ],
  LWB: [
    ['Dribbles', 3],
    ['Key passes', 2],
    ['Tackles', 3],
    ['Passes completed', 35],
  ],
  CDM: [
    ['Interceptions', 2],
    ['Passes completed', 45],
    ['Duels won', 3],
    ['Tackles', 3],
  ],
  CM: [
    ['Passes completed', 40],
    ['Key passes', 2],
    ['Duels won', 3],
    ['Interceptions', 2],
  ],
  CAM: [
    ['Key passes', 2],
    ['Dribbles', 2],
    ['Penalties won', 1],
    ['Shots on target', 2],
  ],
  RW: [
    ['Dribbles', 2],
    ['Key passes', 2],
    ['Fouls suffered', 3],
    ['Penalties won', 1],
  ],
  LW: [
    ['Dribbles', 2],
    ['Key passes', 2],
    ['Fouls suffered', 3],
    ['Penalties won', 1],
  ],
  SS: [
    ['Key passes', 2],
    ['Shots on target', 2],
    ['Penalties won', 1],
    ['Dribbles', 2],
  ],
  ST: [
    ['Shots on target', 2],
    ['Penalties won', 1],
    ['Duels won', 4],
    ['Fouls suffered', 2],
  ],
};

const GOAL: Record<string, number> = {
  GK: 6,
  CB: 6,
  WCB: 6,
  RB: 6,
  LB: 6,
  RWB: 6,
  LWB: 6,
  CDM: 5,
  CM: 5,
  CAM: 5,
  RW: 5,
  LW: 5,
  SS: 4,
  ST: 4,
};

const CLEAN: Record<string, number> = {
  GK: 4,
  CB: 4,
  WCB: 4,
  RB: 4,
  LB: 4,
  RWB: 2,
  LWB: 2,
  CDM: 1.5,
  CM: 1,
  CAM: 0,
  RW: 0,
  LW: 0,
  SS: 0,
  ST: 0,
};

const LABEL: Record<string, string> = {
  GK: 'Goalkeeper',
  CB: 'Centre-back',
  WCB: 'Wide centre-back',
  RB: 'Right back',
  LB: 'Left back',
  RWB: 'Right wing-back',
  LWB: 'Left wing-back',
  CDM: 'Central defensive midfielder',
  CM: 'Central midfielder',
  CAM: 'Central attacking midfielder',
  RW: 'Right winger',
  LW: 'Left winger',
  SS: 'Second striker',
  ST: 'Striker',
};

const COLOR: Record<string, string> = {
  GK: '#F0A020',
  CB: '#0FAF9E',
  WCB: '#0FAF9E',
  RB: '#22B455',
  LB: '#22B455',
  RWB: '#22B455',
  LWB: '#22B455',
  CDM: '#2C97E8',
  CM: '#2C97E8',
  CAM: '#8B5CF6',
  SS: '#8B5CF6',
  RW: '#F2810C',
  LW: '#F2810C',
  ST: '#E5303A',
};

function hexToRgb(hex: string): string {
  return [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ].join(',');
}

export const SCORING_ROLES: ScoringRole[] = Object.keys(BONUS).map((pos) => ({
  pos,
  label: LABEL[pos],
  color: COLOR[pos],
  chipBg: `rgba(${hexToRgb(COLOR[pos])},.16)`,
  chipBorder: `rgba(${hexToRgb(COLOR[pos])},.45)`,
  bonuses: BONUS[pos].map(([stat, every]) => ({
    stat,
    every: String(every),
  })),
  goal: `+${GOAL[pos]}`,
  clean: CLEAN[pos] ? `+${CLEAN[pos]}` : '—',
}));

export const SHARED_EVENTS: SharedEvent[] = [
  { label: 'Assist', pts: '+3', color: '#7fe09c' },
  { label: 'Goal', pts: '+4 to +6', color: '#7fe09c' },
  { label: 'Clean sheet', pts: 'up to +4', color: '#7fe09c' },
];
